import script from "./NotificationMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&setup=true&lang=js"

import "./NotificationMessage.vue?vue&type=style&index=0&id=748c5b29&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748c5b29"]])

export default __exports__